import { Component, OnInit } from '@angular/core';
import { BasePageComponent } from '@carm/_utils/base-page.component';

@Component({
  selector: 'carm-recourse-terms',
  templateUrl: './recourse-terms.component.html',
  styleUrls: ['./recourse-terms.component.scss']
})
export class RecourseTermsComponent extends BasePageComponent implements OnInit {

  public termsAndConditions = this.translateService.instant('components.confirmTermsDialog.recourse');

  constructor() {
    super();
  }

  ngOnInit(): void {
  }
}
